import { render, staticRenderFns } from "./AmbinetLight.vue?vue&type=template&id=b105042a&"
import script from "./AmbinetLight.vue?vue&type=script&lang=js&"
export * from "./AmbinetLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports